import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography, Grid } from "@mui/material";
import * as turf from "@turf/turf";

import useAnalytics from '../../hooks/useAnalytics';
import RegionSelect from "./region-select.component";
import StyledPaper from "../common/styled-paper.component";
import environment from '../../environment/environment';
import useMap from '../../hooks/mapbox/useMap';
import useMarker from '../../hooks/mapbox/useMarker';
import MarkerMap from "../../assets/images/marker-map.png";
import { mapBox } from "./../../common/staticVariables";
import moment from "moment";

function formatTopVerifiedProductsVsVerificationLatLong(top_product_auth_vs_verification_lat_long){
    var data = [];
    for(var i=0; i < top_product_auth_vs_verification_lat_long.length; i++){
        top_product_auth_vs_verification_lat_long[i].locations.forEach(element => {

            let statusColor = element.status === "Suspicious" ? "#fda501" : element.status === "Successful" ? "#3fbf7e" : "#e67260";
            let formattedTimestamp = moment(element.timestamp).format("MMMM DD, YYYY h:mm:ss A");
           
            var jsonObject = {
                type: 'Feature',
                properties: {
                    product: top_product_auth_vs_verification_lat_long[i].product_name,
                    description: `
                        <div class="custom-popup">
                            <p><b>Product Name: </b>${top_product_auth_vs_verification_lat_long[i].product_name}</p>
                            <p><b>Product Code: </b>${top_product_auth_vs_verification_lat_long[i].product_code}</p>
                            <p><b>Verification Count: </b>${top_product_auth_vs_verification_lat_long[i].verificationCount}</p>
                            <p><b>Authentication Count: </b>${top_product_auth_vs_verification_lat_long[i].authenticationCount}</p>
                            <p><b>Status: </b><span style="color: ${statusColor};">${element.status}</span></p>
                            <p><b>Timestamp: </b>${formattedTimestamp}</p>
                        </div>
                    `
                },
                geometry: {
                    type: 'Point',
                    coordinates: [element.longitude, element.latitude]
                }
            };

            if (element.longitude === jsonObject.geometry.coordinates[0] && 
                element.latitude === jsonObject.geometry.coordinates[1]) {
        
                jsonObject.properties.status = element.status;
                jsonObject.properties.timestamp = element.timestamp;
            }
           
            console.log("jsonObject.geometry.coordinates: " + jsonObject.geometry.coordinates)
            data.push(jsonObject);
        });
    }
    const mapBoxCustomData = {
        type: 'FeatureCollection',
        features: data
    }
    return mapBoxCustomData;
}


const getCenterCamera = (formatted_top_product_auth_vs_verification_lat_long) => {

    var transformedCoordinates = [];
    formatted_top_product_auth_vs_verification_lat_long.features.forEach((element)=>{
        var coords = [];
        coords.push(element.geometry.coordinates[0]);
        coords.push(element.geometry.coordinates[1]);
        transformedCoordinates.push(coords);
    })
    // transformedCoordinates = data.map(({ lng, lat }) => [lng, lat]);
    console.log("transformedCoordinates 11", transformedCoordinates);

    let centerCamera;
    
    const polygon = {
        type: 'Feature',
        geometry: {
            type: 'Polygon',
            coordinates: [
                transformedCoordinates
            ]
        }
    };

    // For center focus camera map
    if (transformedCoordinates.length == 1) {
        polygon.geometry.coordinates = transformedCoordinates[0];
        centerCamera = polygon;
    } else {
        centerCamera = turf.centroid(polygon);
    }

    return centerCamera
}

const MapAnalytics = ({parentHeight}) => {

    const { loading, error, top_product_auth_vs_verification_lat_long, getTopProductAuthVsVerificationLatLong } = useAnalytics();
    const [region, setRegion] = useState(null);
    const [country, setCountry] = useState(null);
    const [formatted_top_product_auth_vs_verification_lat_long, setFormattedTopProductAuthVsVerificationLatLong] = useState(null);

    const mapContainerRef = useRef();
    const mapRef = useRef();
    const {map, mapLoaded, initMap, addSource, getSource} = useMap(mapRef);
    const {addMarkersWithLayer, getMarkersWithLayer} = useMarker(map);

    useEffect(()=>{
        if(country == null) return;
        if(region == null) return;
        getTopProductAuthVsVerificationLatLong(country, region);
    }, [region, country]);

    useEffect(()=>{
        if(top_product_auth_vs_verification_lat_long == null) return;
        var data = formatTopVerifiedProductsVsVerificationLatLong(top_product_auth_vs_verification_lat_long);
        setFormattedTopProductAuthVsVerificationLatLong(data);
    }, [top_product_auth_vs_verification_lat_long]);

    useEffect(()=>{

        if (!mapLoaded) {
            let mapOpts = {
                token: environment.mapBox.mapBoxToken,
                containerRef: mapContainerRef.current,
                style: 'mapbox://styles/mapbox/streets-v12',
                center: [-24, 42],
                zoom: 1
            }
            initMap(mapOpts);
            return;
        }

        // 2. add markers
        // 2.1 initialize source
        if(formatted_top_product_auth_vs_verification_lat_long == null) return;
        var source_id = 'anomaly-detection-map-id';
        if(getSource(source_id) == null){ // checks if source is already available. else, do nothing.
            var mapBoxCustomData = formatted_top_product_auth_vs_verification_lat_long;
            console.log("mapBoxCustomData: ", mapBoxCustomData)
            let obj = {
                type: 'geojson',
                data: mapBoxCustomData
            }
            addSource(source_id, obj); // returns void
        }

        // 2.2 get marker layer options
        var markers_layer_id = 'anomaly-detection-markers-layer-id';
        var marker_layer = getMarkersWithLayer(markers_layer_id);
        var marker_layer_options;
        if(marker_layer == null){
            var img_marker_id = mapBox.marker.icon_img_id
            marker_layer_options = {
                id: markers_layer_id,
                icon_img_id: img_marker_id,
                icon_src: MarkerMap,
                size: 0.3,
                popup: {
                    isHover: true,
                }
            }
        } else {
            marker_layer.updateData(formatted_top_product_auth_vs_verification_lat_long)
        }

        // 2.3 get camera options
        // get center of all lat long's
        // TODO: update center camera everytime lat lng changes
        var centerCamera = getCenterCamera(formatted_top_product_auth_vs_verification_lat_long);
        let camera_options = {
            center: centerCamera.geometry.coordinates,
            zoom: 5,
        }

        // 3. final marker setup
        if(marker_layer) return;
        addMarkersWithLayer(source_id, marker_layer_options, camera_options);

    }, [formatted_top_product_auth_vs_verification_lat_long, mapLoaded])

    // if (formatted_top_product_auth_vs_verification_lat_long === null) return <StyledPaper>
    //     <Grid container sx={{pb: 2}}>
    //         <Grid item xs={12} sm={6} lg={9}>
    //             <Typography>Verification Locations</Typography>
    //         </Grid>
    //         <Grid item xs={12} sm={6} lg={3}>
    //             <RegionSelect onRegionChange={setRegion} onCountryChange={setCountry}/>
    //         </Grid>
    //     </Grid>

    //     <Box sx={{textAlign: "center", flexDirection: "column", mb: 17,
    //         justifyContent: "center", display: "flex", alignItems: "center", 
    //     }}>
    //         <img alt="empty-data-icon" src={EmptyIcon} width="110" style={{marginTop: "110px"}} />

    //         <Typography sx={{color: "#58565f", fontSize: 14, mt: 1}}>
    //             No verification data available for the selected region
    //         </Typography>
    //     </Box>
    // </StyledPaper>


    return(
        <>
            <StyledPaper>
                <Grid container sx={{pb: 2}}>
                    <Grid item xs={12} sm={6} lg={9}>
                        <Typography>Verification Locations</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                        <RegionSelect onRegionChange={setRegion} onCountryChange={setCountry}/>
                    </Grid>
                </Grid>

                <Box id="map" ref={mapContainerRef} sx={{ height: parentHeight }} />
             </StyledPaper>
        </>
    )

}

export default MapAnalytics;